// extracted by mini-css-extract-plugin
export var footer = "_pn-0";
export var inherit = "_pn-1";
export var input = "_pn-2";
export var modalContent = "_pn-3";
export var quillEditor = "_pn-4";
export var subtitle = "_pn-5";